import { memo, type ReactNode } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Portal } from '@air/primitive-portal';

type MobileCommentsPanelWrapperProps = {
  onClose: () => void;
  CommentsPanel: ReactNode;
};

export const MobileCommentsPanelWrapper = memo(({ onClose, CommentsPanel }: MobileCommentsPanelWrapperProps) => {
  return (
    <Portal>
      <div className="fixed inset-y-0 left-0 flex w-screen flex-col ads:bg-base bg-gray-1">
        <div className="flex h-12 items-center justify-between border-b ads:border-b-ads-gray-5 border-b-gray-5 px-6">
          <div className="font-semibold ads:text-primary text-16 text-gray-12">Comments</div>
          <IconButton
            adsIcon
            appearance="ghost"
            color="gray"
            icon={XIcon}
            label="Close comments"
            onClick={onClose}
            size="small"
          />
        </div>
        <div className="flex w-full flex-1 shrink-0 flex-col overflow-auto px-4">{CommentsPanel}</div>
      </div>
    </Portal>
  );
});

MobileCommentsPanelWrapper.displayName = 'MobileCommentsPanelWrapper';
